import { useCMSPageField } from '@/cms/fields'
import { buildImgSrc, buildImgSrcSet, ImageOrigin } from '@/helpers/image-url'
import { useIntl } from '@/intl'
import { PublicationCodes } from '@/scopes/common/domain/models'
import { useConfiguration } from '@/scopes/common/infrastructure/config/ConfigProvider'
import { Benefits } from '@sunwebgroup/uds-ui/benefits'
import { Button } from '@sunwebgroup/uds-ui/button'
import { LazyImage } from '@sunwebgroup/uds-ui/lazy-image'
import { Typography } from '@sunwebgroup/uds-ui/typography'
import { useEffect, useState } from 'react'
import styles from './DestinationCards.module.css'

export function DestinationCards() {
  const intl = useIntl()
  const countries = useCMSPageField('DestinationsPage.countries')
  const [isMounted, setIsMounted] = useState(false)
  const publicationCode = useConfiguration('publicationCode')
  const season = PublicationCodes.isSunwebWinterPublicationCode(publicationCode) ? 'winter' : 'summer'

  const buttonTranslationKeyBySeason = {
    winter: 'destinations_page_country_button_text__winter',
    summer: 'destinations_page_country_button_text__summer',
  }

  useEffect(() => {
    setIsMounted(true)
  }, [])

  return (
    <div className={styles.container}>
      {countries?.map((country, index) => (
        <div className={styles.card} key={`country-card-${index}`} data-qa="country-card">
          {isMounted && (
            <LazyImage
              src={buildImgSrc(country.image, 480, undefined, ImageOrigin.CMSSitecore)}
              alt={country.title}
              aspectRatio="16:9"
              placeholderSrc={buildImgSrc(country.image, 480, undefined, ImageOrigin.CMSSitecore)}
              srcSet={buildImgSrcSet(country.image ?? '', [320, 480, 600])}
              className={styles.image}
            />
          )}
          <div className={styles.content}>
            <div>
              <Typography variant="display-g-regular" as="h3">
                {country.title}
              </Typography>
              <Benefits.Root display="list">
                {country.usps?.map((usp, index) => (
                  <Benefits.Item key={`country-page-usp-${index}`} title={usp} />
                ))}
              </Benefits.Root>
            </div>
            <Button variant="outlinedPrimary" as="a" size="M" href={country.link}>
              {intl.formatMessage({ id: buttonTranslationKeyBySeason[season] })}
            </Button>
          </div>
        </div>
      ))}
    </div>
  )
}
